import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import { HttpConnector } from '@/modules/shared/domain/connectors/http';
import TYPES from '@/types';
import { CreateCellPhoneRepository } from '../../../domain/repository/create-cell-phone-repository';
import { CreateCellphoneDto } from '../../../domain/dtos/create-cellphone-dto';

@Injectable()
export default class CreateCellPhoneHttpRepository implements CreateCellPhoneRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly path = `${process.env.VUE_APP_API_URL}/api/v1/app/on-boarding/cellphones/`;

  execute(phone: CreateCellphoneDto): Promise<void> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.path, 'POST', phone)
        .then((response) => {
          response.json().then(({ message, success }) => {
            if (success) {
              resolve();
            } else {
              reject(new Error(message));
            }
          });
        })
        .catch(reject);
    });
  }
}
